import { Component } from "react";

class CounterThree extends Component {
    state = {count: 0}

    // increment = () => {
    //     this.setState({
    //         count: this.state.count + 1
    //     });
    // }

     decrement = () => {
        this.setState({
            count: this.state.count - 1
        });
    }

    render () {
        return (
           <section>
            <h2>Class with State Object (old practice)</h2>
            <div className="counter">
                <input type="button" value="Minus" onClick={this.decrement}/>
                <input type="text" value={this.state.count} readOnly />
                <input type="button" value="Plus" onClick={() => {this.setState({count:this.state.count + 1})}}/>
            </div>
            </section>
        )
    }
}

export default CounterThree;